module.exports = __webpack_public_path__ + "img/news01-Redes.3cef9d44.jpg";